import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  responseType: 'json'
});

/* Surfaces the backend's message when there is one. Without the fallback a
   network failure or CORS error — no response, so no message — became an
   empty Error, which sign-in then reported as "Permission denied". */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const backendMessage = error.response?.data?.message;
    throw new Error(
      (Array.isArray(backendMessage) ? backendMessage.join('; ') : backendMessage) || error.message || 'Request failed'
    );
  }
);

export default api;
